import { OrderRecordDetail } from "@/interface/order";
import { OperationReportModel } from "@/interface/report";
import { DriverTraceViewModel, OrderTraceRecord } from "@/interface/trace";
import { FetchResult, GetJsonWithToken } from "../apihandler";

export function GetTraceByOrderNo(
  orderno: string,
): Promise<FetchResult<DriverTraceViewModel>> {
  return GetJsonWithToken<DriverTraceViewModel>(
    `api/Records/GetTraceByOrderNo?orderNo=${orderno}`,
  );
}

export function GetOrderDetail(
  orderno: string,
): Promise<FetchResult<OrderRecordDetail>> {
  return GetJsonWithToken<OrderRecordDetail>(
    `api/Records/GetOrderDetail/${orderno}`,
  );
}

export function OperationMonthReport(
  month: Date,
): Promise<FetchResult<OperationReportModel>> {
  return GetJsonWithToken<OperationReportModel>(
    `api/Records/OperationMonthReport?month=${month.toJSON()}`,
  );
}

export function OperationDayReport(
  day: Date,
): Promise<FetchResult<OperationReportModel>> {
  return GetJsonWithToken<OperationReportModel>(
    `api/Records/OperationDayReport?day=${day.toJSON()}`,
  );
}

export function GetOrderStatusTrace(
  orderno: string,
): Promise<FetchResult<OrderTraceRecord>> {
  return GetJsonWithToken<OrderTraceRecord>(
    `api/Records/GetOrderStatusTrace?orderNo=${orderno}`,
  );
}
